<template>
  <div class="print-page full-height">
    <table-con>
      <div slot="search">
        <el-form ref="form" :model="queryInfo" size="small" label-width="5rem" label-position="right">
          <el-row :gutter="24">
            <el-col :span="7" class="display-row">
              <div class="query-title">购买账号:</div>
              <div class="flex1">
                <el-select filterable v-model="queryInfo.buyAccountId" @change="handleQuery" placeholder="请选择" size="small">
                  <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="15" class="display-row">
              <div class="order-toolbar" style="height: 30px;line-height: 30px;">
                <el-checkbox
                    :indeterminate="isIndeterminate"
                    :value="isAllChecked"
                    @change="toggleAll"
                >
                  全选
                </el-checkbox>
                <span class="selected-info" style="margin-left: 10px;">
                  已选 <span style="color: #1481d1">{{ selectedCount }}</span> 笔订单
                </span>
                <span class="selected-info" v-if="selectedCount > 0">
                  ,<span style="margin-left: 10px;">总金额：<span style="color: #1481d1">{{ allMoney }}</span> 元</span>
                  (<span style="">商品费：<span style="color: #1481d1">{{ spMoney }}</span> 元</span>,
                  <span style="">运费：<span style="color: #1481d1">{{ yunMoney }}</span> 元</span>)
                </span>
              </div>
            </el-col>
            <div style="display: flex;justify-content: end;">
              <el-button class="search-btn btn-blue" :disabled="!selectedCount" @click="payBatch">批量支付</el-button>
              <el-button class="search-btn btn-gray" @click="handleReset">重置 </el-button>
              <el-button class="search-btn btn-blue" @click="handleQuery">搜索</el-button>
            </div>
          </el-row>
        </el-form>

      </div>
      <!-- 表格 -->
      <div slot="table" class="full-height display-col">
        <el-table
            :data="orderList"
            row-key="idOfStr"
            :show-header="false"
            class="order-table"
            v-loading="loading"
        >
          <el-table-column>
            <template slot-scope="{ row }">
              <OrderCard
                  :order="row"
                  :checked="!!selectedOrderMap[row.idOfStr]"
                  @checked-change="handleCheckedChange"
              />
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
      </div>

    </table-con>
  </div>
</template>

<script>
import { TableResize } from '@/assets/js/utils'
import OrderCard from './components/OrderCard.vue'
import {formatMoney} from '@/assets/js/utils'

export default {
  name: 'OrderPay',
  components: {OrderCard},
  data() {
    return {
      formatMoney,
      tableResize: new TableResize(260),
      queryInfo: {
        buyAccountId:'',
        pageNum: 1,
        pageSize: 10,
      },
      buyAcountList: [],
      total: 10,
      loading: false,
      selectedOrderMap: {},   // ⭐ 跨分页选中池
      orderList: [],
    }
  },
  computed: {
    currentPageOrderIds() {
      return this.orderList.map(o => o.idOfStr)
    },
    selectedCount() {
      return Object.keys(this.selectedOrderMap).length
    },
    isAllChecked() {
      if (!this.orderList.length) return false
      return this.currentPageOrderIds.every(
          id => this.selectedOrderMap[id]
      )
    },
    isIndeterminate() {
      if (!this.orderList.length) return false

      const checkedCount = this.currentPageOrderIds.filter(
          id => this.selectedOrderMap[id]
      ).length

      return checkedCount > 0 && checkedCount < this.currentPageOrderIds.length
    },
    allMoney() {
      let sum = 0
      let smallArr = Object.keys(this.selectedOrderMap)
      let arr = this.orderList.filter(o => {
        return smallArr.includes(o.idOfStr)
      })
      for (let i = 0; i < arr.length; i++) {
        sum += arr[i].totalAmount
      }
      return formatMoney(sum)
    },
    spMoney() {
      let sum = 0
      let smallArr = Object.keys(this.selectedOrderMap)
      let arr = this.orderList.filter(o => {
        return smallArr.includes(o.idOfStr)
      })
      for (let i = 0; i < arr.length; i++) {
        sum += arr[i].totalAmount - arr[i].shippingFee
      }
      return formatMoney(sum)
    },
    yunMoney() {
      let sum = 0
      let smallArr = Object.keys(this.selectedOrderMap)
      let arr = this.orderList.filter(o => {
        return smallArr.includes(o.idOfStr)
      })
      for (let i = 0; i < arr.length; i++) {
        sum += arr[i].shippingFee
      }
      return formatMoney(sum)
    },
  },
  mounted() {
    this.tableResize.onRun()
    // console.log('onRun', this.tableResize)
  },
  destroyed() {
    this.tableResize.onStop()
  },
  created() {
    this.getBuyAccountList()
  },
  methods: {
    async getList() {
      const { data: res } = await this.$http.get("/shop/1688/goods/get1688OrderList", { params: this.queryInfo });
      if(res.code === 200) {
        // console.log(res,1122)
        this.orderList = res.data.list.map(v => {
          return {
            ...v,
            ...v.baseInfo
          }
        })
        this.total = res.data.total
        // console.log(this.orderList,1122)
      }else {
        this.orderList = []
        this.total = 0
        this.$message.warning(res.message)
      }
    },
    // 搜索
    handleQuery() {
      this.queryInfo.pageNum = 1
      this.getList()
    },
    // 重置
    handleReset() {
      this.queryInfo.pageNum = 1
      this.queryInfo.buyAccountId = this.buyAcountList[0].id
      this.getList()
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getList();
    },
    getBuyAccountList () {
      this.$http.get("cms/configAccountNumber/getListByType?type=1").then((res) => {
        this.buyAcountList = res.data.data
        this.buyAcountList.map((res) => {
          if (res.platformType !== null) {
            switch (res.platformType) {
              case "0":
                return (res.platformType_hanzi = "淘宝 -" + res.accountNumber)
                break
              case "1":
                return (res.platformType_hanzi = "1688 -" + res.accountNumber)
                break
              case "2":
                return (res.platformType_hanzi = "京东 -" + res.accountNumber)
                break
              case "3":
                return (res.platformType_hanzi =
                    "拼多多 -" + res.accountNumber)
                break
              case null:
                return (res.platformType_hanzi = "")
                break
            }
          }
        })
        this.queryInfo.buyAccountId = res.data.data[0].id
        this.getList()
      })
    },
    handleCheckedChange({ checked, order }) {
      if (checked) {
        this.$set(this.selectedOrderMap, order.idOfStr, order)
      } else {
        this.$delete(this.selectedOrderMap, order.idOfStr)
      }
    },
    toggleAll(checked) {
      if (checked) {
        // ✅ 全选当前页
        this.orderList.forEach(order => {
          this.$set(this.selectedOrderMap, order.idOfStr, order)
        })
      } else {
        // ❌ 取消当前页选择
        this.orderList.forEach(order => {
          this.$delete(this.selectedOrderMap, order.idOfStr)
        })
      }
    },
    clearSelected() {
      this.selectedOrderMap = {}
    },
    payBatch(){
      const selectedOrders = Object.values(this.selectedOrderMap)
      if (!selectedOrders.length) {
        return this.$message.warning('请选择需要支付的订单')
      }
      const orderIds = Object.keys(this.selectedOrderMap)
      console.log(orderIds,1122)
      this.$confirm('此操作将进行批量支付, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const params = {
          buyAccountId: this.queryInfo.buyAccountId,
          orderIds: orderIds.join(','),
        }
        const res = await this.$http.get("/shop/1688/goods/pay1688Order", { params });
        console.log(res,1122)
        if(res.data.code === 200){
          this.selectedOrderMap = {}
          setTimeout(()=>{
            this.handleQuery()
          },3000)
          this.$message({
            type: 'success',
            message: res.data.message
          });
        }else {
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消该操作'
        });
      });
    }
  }
}
</script>
